import { ref, type Ref, shallowRef } from "vue";
import * as Cesium from "cesium";

export function useGaussianSplats(
    viewer: Ref<Cesium.Viewer | null>,
) {
    const officeGSplatsTileset = shallowRef<Cesium.Cesium3DTileset | null>(null);
    const officeGSplatsTileset2 = shallowRef<Cesium.Cesium3DTileset | null>(null);
    const factoryGSplatsTileset = shallowRef<Cesium.Cesium3DTileset | null>(null);
    const varennesGSplatsTileset = shallowRef<Cesium.Cesium3DTileset | null>(null);


    const showOfficeGSplats = ref<boolean>(false);
    const showSecondOfficeGSplats = ref<boolean>(false);
    const showFactoryGSplats = ref<boolean>(false);
    const showVarennesGSplats = ref<boolean>(false);


    const toggleOfficeGSplats = async (): Promise<void> => {
        if (!viewer.value) return;

        showOfficeGSplats.value = !showOfficeGSplats.value;

        if (showOfficeGSplats.value) {
            const tileset = await Cesium.Cesium3DTileset.fromIonAssetId(4133286);
            officeGSplatsTileset.value = viewer.value.scene.primitives.add(tileset);
        } else {
            if (officeGSplatsTileset.value) {
                viewer.value.scene.primitives.remove(officeGSplatsTileset.value);
                officeGSplatsTileset.value = null;
            }
        }
        viewer.value.scene.requestRender();
    };

    const toggleSecondOfficeGSplats = async (): Promise<void> => {
        if (!viewer.value) return;

        showSecondOfficeGSplats.value = !showSecondOfficeGSplats.value;

        if (showSecondOfficeGSplats.value) {
            const tileset = await Cesium.Cesium3DTileset.fromIonAssetId(4191927);
            officeGSplatsTileset2.value = viewer.value.scene.primitives.add(tileset);
        } else {
            if (officeGSplatsTileset2.value) {
                viewer.value.scene.primitives.remove(officeGSplatsTileset2.value);
                officeGSplatsTileset2.value = null;
            }
        }
        viewer.value.scene.requestRender();
    };

    const toggleFactoryGSplats = async (): Promise<void> => {
        if (!viewer.value) return;

        showFactoryGSplats.value = !showFactoryGSplats.value;

        if (showFactoryGSplats.value) {
            const tileset = await Cesium.Cesium3DTileset.fromIonAssetId(4161867);
            factoryGSplatsTileset.value = viewer.value.scene.primitives.add(tileset);
        } else {
            if (factoryGSplatsTileset.value) {
                viewer.value.scene.primitives.remove(factoryGSplatsTileset.value);
                factoryGSplatsTileset.value = null;
            }
        }
        viewer.value.scene.requestRender();
    };

    const toggleVarennesGSplats = async (): Promise<void> => {
        if (!viewer.value) return;

        showVarennesGSplats.value = !showVarennesGSplats.value;

        if (showVarennesGSplats.value) {
            const tileset = await Cesium.Cesium3DTileset.fromIonAssetId(4171436);
            varennesGSplatsTileset.value = viewer.value.scene.primitives.add(tileset);
        } else {
            if (varennesGSplatsTileset.value) {
                viewer.value.scene.primitives.remove(varennesGSplatsTileset.value);
                varennesGSplatsTileset.value = null;
            }
        }
        viewer.value.scene.requestRender();
    };

    return {
        showOfficeGSplats,
        showSecondOfficeGSplats,
        showFactoryGSplats,
        showVarennesGSplats,
        toggleOfficeGSplats,
        toggleSecondOfficeGSplats,
        toggleFactoryGSplats,
        toggleVarennesGSplats
    };
}